import {SERVER_GG_STORE_REPLY} from '../../constans/index';
import {
    GOOGLE_REPLY_REQUEST,
    GOOGLE_REPLY_SUCCESS,
    GOOGLE_REPLY_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const GoogleReplyCommentAction = (id, data_target) => ({

    [RSAA]: {
        endpoint: `${SERVER_GG_STORE_REPLY}/api/games/${id}/comments`,
        method: 'POST',
        headers: (headers()),
        body: (() => {
            return JSON.stringify(data_target);
        }),
        types: [
            GOOGLE_REPLY_REQUEST,
            {
                type: GOOGLE_REPLY_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": GOOGLE_REPLY_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: GOOGLE_REPLY_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": GOOGLE_REPLY_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {GoogleReplyCommentAction}